<mat-grid-list cols="6">
	<mat-grid-tile *ngFor="let icon of icons" (click)="okay(icon)" [colspan]="1">
		<i class="fa-2x fa {{ icon }}"></i>
	</mat-grid-tile>
</mat-grid-list>
